import { FunctionComponent } from 'react';

type Props = {
  size?: number;
};

export const Spacer: FunctionComponent<Props> = ({ size = 2 }) => (
  <div className={`mt-${size}`} />
);
